<template>
  <a-modal
    :visible="visible"
    :destroy-on-close="true"
    @cancel="$emit('close')"
    @ok="handleUpdateCharacteristic"
  >
    <h3>Edit characteristic</h3>

    <a-form layout="horizontal">
      <a-form-item
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 16 }"
        :validate-status="errors.first('title') ? 'error' : ''"
        :help="errors.first('title')"
        label="Title"
      >
        <a-input
          v-model="updatedCharacteristic.title"
          v-validate="'required|max:255'"
          placeholder="Characteristic title"
          data-vv-name="title"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script setup lang="ts">
import { ref, watch, getCurrentInstance } from "vue";
import { CharacteristicPayloadInterface } from "../types";
import useMixin from "@/useMixin";

// Props
const props = defineProps({
  characteristic: { type: Object as () => CharacteristicPayloadInterface, default: undefined },
  visible: { type: Boolean, default: false },
});

// Emits
const emits = defineEmits(["update-characteristic", "close"]);

const updatedCharacteristic = ref<CharacteristicPayloadInterface>({
  id: undefined,
  title: undefined,
});

// Mixins
const { setObject } = useMixin();

// Watchers
watch(
  () => props.visible,
  (newProp, oldProp) => {
    if (newProp && !oldProp) {
      updatedCharacteristic.value = setObject(updatedCharacteristic.value, props.characteristic);
    }
  }
);

// Class Methods
const instance = getCurrentInstance();
const $validator = instance?.proxy.$validator;
const handleUpdateCharacteristic = (): void => {
  $validator?.validateAll().then((result) => {
    if (result) {
      emits("update-characteristic", updatedCharacteristic.value);
      emits("close");
    }
  });
};
</script>
